/* KAARKASH editorial header.
   Wide screens: panels under the navigation. Pointer — a panel opens for the link it
   belongs to and closes a moment after the pointer leaves; a row in it opens the panel
   beside it. Touch and keyboard — the trigger toggles; Escape closes everything and hands
   focus back.
   Phones: the menu that slides in under the bar — panels that slide over one another, rows
   that unfold in place, the country at the foot.
   Pictures are fetched when the panel that holds them opens. */
(function () {
  'use strict';
  if (window.__kkHeader) { window.__kkHeader.scan(); return; }

  var WIDE = '(min-width: 1100px)';
  var OPEN_AFTER = 60, CLOSE_AFTER = 220, SLIDE = 280;
  var FADE = 400;                 // the backdrop is gone 320ms after a panel shuts
  var root = document.documentElement;
  var wide = window.matchMedia(WIDE);
  var canHover = window.matchMedia('(hover: hover)');
  var overlay = null, closing = 0;

  /* ---------- shared ---------- */
  // Panels start where the bar ends, wherever the bar is at that moment.
  function underBar() {
    var bar = document.querySelector('.section-header .header-wrapper');
    if (!bar) return;
    var bottom = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    root.style.setProperty('--kkhd-bottom', bottom + 'px');
  }
  function pictures(scope) {
    scope.querySelectorAll('img[data-kk-src]').forEach(function (img) {
      // only this panel's own pictures, not those of panels inside it that are still shut
      var holder = img.closest('[data-kkn-panel], [data-kkmn-panel]');
      if (holder && holder !== scope && scope.contains(holder)) return;
      function shown() { img.classList.add('is-in'); }
      img.addEventListener('load', shown, { once: true });
      img.addEventListener('error', function () { img.remove(); }, { once: true });
      img.src = img.getAttribute('data-kk-src');
      img.removeAttribute('data-kk-src');
      if (img.complete && img.naturalWidth) shown();
    });
  }

  /* ---------- wide screens ----------
     An item on the bar owns a panel down the left edge, and that panel's rows may each own a
     second panel beside it. The second panels stand next to the first in the page, not inside
     its rows (the first one moves as it opens), so a row names its panel: data-kkn-side. */
  function trigger(item) {
    for (var i = 0; i < item.children.length; i++) {
      if (item.children[i].hasAttribute('data-kkn-trigger')) return item.children[i];
    }
    return null;
  }
  function panelOf(item) {
    for (var i = 0; i < item.children.length; i++) {
      var child = item.children[i];
      if (child.hasAttribute('data-kkn-panel') && !child.hasAttribute('data-kkn-side-panel')) return child;
    }
    return null;
  }
  function backdrop() {
    if (overlay) return overlay;
    overlay = document.createElement('span');     // not a div: the theme hides every empty div
    overlay.className = 'kkn-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeAll);
    document.body.appendChild(overlay);
    return overlay;
  }
  function sync() {
    var open = !!document.querySelector('.kkn [data-kkn-item].is-open');
    var was = root.classList.contains('kkn-is-open');
    if (open) backdrop();
    root.classList.toggle('kkn-is-open', open);
    // On the way out the bar stays in front of the backdrop until the backdrop has faded.
    // Dropped behind it at once, the panel would shut under the blur, and the pointer would
    // find the backdrop where the link had been: the link "left", then "entered" again when
    // the backdrop went, and the menu opened itself a moment after being shut.
    if (open) {
      clearTimeout(closing);
      root.classList.remove('kkn-is-closing');
    } else if (was) {
      clearTimeout(closing);
      root.classList.add('kkn-is-closing');
      closing = setTimeout(function () { root.classList.remove('kkn-is-closing'); }, FADE);
    }
    var section = document.querySelector('.section-header');
    if (section) section.classList.toggle('kkn-open', open);
  }

  // second panels
  function sideOf(row) {
    var id = row.getAttribute('data-kkn-side');
    return id ? document.getElementById(id) : null;
  }
  function setSide(row, open) {
    clearTimeout(row.__kknTimer);
    var side = sideOf(row);
    if (!side || row.classList.contains('is-open') === open) return;
    if (open) {
      // a second panel never stands without its first
      var item = row.closest('[data-kkn-item]');
      if (item && !item.classList.contains('is-open')) return;
      shutOthers(row);
      pictures(side);
      side.scrollTop = 0;
    }
    row.classList.toggle('is-open', open);
    side.classList.toggle('is-open', open);
    var link = row.querySelector('.kkn__sublink');
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  // one second panel at a time: the rows beside this one put theirs away
  function shutOthers(row) {
    var rows = row.parentNode.children;
    for (var i = 0; i < rows.length; i++) if (rows[i] !== row) setSide(rows[i], false);
  }
  function sideLater(row, open, wait) {
    clearTimeout(row.__kknTimer);
    row.__kknTimer = setTimeout(function () { setSide(row, open); }, wait);
  }
  function closeSides(item) {
    // every row, not only the open ones: a row pointed at a moment ago still has its "show" waiting
    item.querySelectorAll('[data-kkn-side]').forEach(function (row) { setSide(row, false); });
  }

  function set(item, open) {
    clearTimeout(item.__kknTimer);
    if (item.classList.contains('is-open') === open) return;
    if (open) {
      // one at a time, across both sides of the logo
      document.querySelectorAll('.kkn__list > .kkn__item.is-open').forEach(function (other) { if (other !== item) set(other, false); });
      underBar();
      var panel = panelOf(item);
      if (panel) { pictures(panel); panel.scrollTop = 0; }
    } else {
      closeSides(item);
    }
    item.classList.toggle('is-open', open);
    var t = trigger(item);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    sync();
  }
  function later(item, open, wait) {
    clearTimeout(item.__kknTimer);
    item.__kknTimer = setTimeout(function () { set(item, open); }, wait);
  }
  function closeAll() {
    document.querySelectorAll('.kkn [data-kkn-item].is-open').forEach(function (item) { set(item, false); });
  }

  function wire(item) {
    if (item.__kknWired) return;
    item.__kknWired = true;
    var t = trigger(item);
    if (!t) return;

    item.addEventListener('mouseenter', function () { if (wide.matches && canHover.matches) later(item, true, OPEN_AFTER); });
    item.addEventListener('mouseleave', function () { if (wide.matches && canHover.matches) later(item, false, CLOSE_AFTER); });
    t.addEventListener('click', function (e) {
      if (!wide.matches) return;
      e.preventDefault();
      set(item, !item.classList.contains('is-open'));
    });
    item.addEventListener('focusout', function (e) {
      if (!wide.matches) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      later(item, false, CLOSE_AFTER);
    });
  }

  function rowLink(row) { return row ? row.querySelector('.kkn__sublink') : null; }

  function wireRow(row) {
    if (row.__kknRow) return;
    row.__kknRow = true;
    var link = rowLink(row);
    var owns = row.hasAttribute('data-kkn-side');

    // pointing at a row shows its panel; pointing at a plain row puts the open one away
    row.addEventListener('mouseenter', function () {
      if (!wide.matches || !canHover.matches) return;
      if (owns) { sideLater(row, true, OPEN_AFTER); return; }
      var rows = row.parentNode.children;
      for (var i = 0; i < rows.length; i++) if (rows[i].classList.contains('is-open')) sideLater(rows[i], false, OPEN_AFTER);
    });
    // and leaving it for its own panel must not lose it: a pending "show" is kept, nothing is shut
    if (!link) return;

    // The keyboard arriving on a plain row does what the pointer does: the panel of the row
    // it came from is put away. (A row with a panel of its own does so as it shows its own.)
    if (!owns) link.addEventListener('focus', function () { if (wide.matches) shutOthers(row); });

    // ↓ and ↑ step from row to row, past the panels
    link.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var to = rowLink(e.key === 'ArrowDown' ? row.nextElementSibling : row.previousElementSibling);
      if (!to) return;
      e.preventDefault();
      to.focus();
    });
    if (owns) wireSide(row, link);
  }

  // a row with a panel of its own
  function wireSide(row, link) {
    // Whether the panel was open before the finger came down: focus arrives ahead of the
    // click and opens it, so by the time the click is heard "open" no longer says anything.
    var wasOpen = false;
    link.addEventListener('pointerdown', function () { wasOpen = row.classList.contains('is-open'); });
    link.addEventListener('click', function (e) {
      if (!wide.matches) return;
      // where there is no pointer to hover with, the first tap opens the panel and the second
      // follows the link. A keyboard press always follows it.
      var byKeyboard = e.detail === 0;
      if (canHover.matches || byKeyboard || wasOpen) return;
      e.preventDefault();
      setSide(row, true);
    });
    link.addEventListener('focus', function () { if (wide.matches) setSide(row, true); });

    // The panel stands beside its row but is printed after the whole list, so left to itself
    // Tab would go down every row first and reach only the last row's panel. The keyboard
    // walks it as if it sat inside the row: Tab or → steps in, and out again at either end.
    link.addEventListener('keydown', function (e) {
      var into = e.key === 'ArrowRight' || (e.key === 'Tab' && !e.shiftKey);
      if (!into || !wide.matches) return;
      var side = sideOf(row);
      var first = side && side.querySelector('a[href]');
      if (!first) return;
      e.preventDefault();
      setSide(row, true);
      first.focus();
    });
    var side = sideOf(row);
    if (side) side.addEventListener('keydown', function (e) {
      var all = Array.prototype.slice.call(side.querySelectorAll('a[href]'));
      var at = all.indexOf(document.activeElement);
      if (e.key === 'ArrowLeft' || (e.key === 'Tab' && e.shiftKey && at === 0)) {
        e.preventDefault();
        link.focus();
        return;
      }
      if (e.key !== 'Tab' || e.shiftKey || at !== all.length - 1) return;
      // past the last one: on to the row below. After the last row the browser carries on
      // to whatever follows the menu.
      var next = rowLink(row.nextElementSibling);
      if (!next) return;
      e.preventDefault();
      next.focus();
    });
  }

  /* ---------- phones ---------- */
  var menu = null, burger = null, stack = ['root'];

  function panel(name) { return menu.querySelector('[data-kkmn-panel="' + name + '"]'); }
  function focusables() {
    var active = panel(stack[stack.length - 1]);
    var list = [burger].concat(Array.prototype.slice.call(active.querySelectorAll('a[href], button:not([disabled])')));
    var country = menu.querySelector('[data-kkmn-country]');
    if (country && stack.length === 1) list.push(country);
    return list.filter(function (el) { return el && el.offsetParent !== null; });
  }
  // Only the panel on top is there to be read or reached: the ones it covers are still
  // painted beneath it, so they are taken out of reach until it slides away again.
  function cover() {
    var top = stack[stack.length - 1];
    menu.querySelectorAll('[data-kkmn-panel]').forEach(function (p) {
      var under = p.getAttribute('data-kkmn-panel') !== top;
      p.inert = under;
      if (under) p.setAttribute('aria-hidden', 'true'); else p.removeAttribute('aria-hidden');
    });
  }
  function show(name, focus) {
    var next = panel(name);
    if (!next) return;
    pictures(next);
    next.classList.add('is-active');
    next.scrollTop = 0;
    menu.setAttribute('data-kkmn-active', name);
    cover();
    if (focus) {
      var first = next.querySelector('[data-kkmn-back], a[href], button');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, SLIDE);
    }
  }
  function go(name) {
    // a second tap on the same row, landing while its panel is still sliding in, asks for
    // a panel that is already on the stack: it must not be stacked twice
    if (!panel(name) || stack.indexOf(name) !== -1) return;
    stack.push(name);
    show(name, true);
  }
  function back() {
    if (stack.length < 2) return;
    var from = stack.pop();
    var to = stack[stack.length - 1];
    panel(from).classList.remove('is-active');
    menu.setAttribute('data-kkmn-active', to);
    cover();
    var opener = panel(to).querySelector('[data-kkmn-go="' + from + '"]');
    if (opener) opener.focus({ preventScroll: true });
  }
  function openMenu() {
    if (!menu || menu.classList.contains('is-open')) return;
    underBar();
    stack = ['root'];
    menu.querySelectorAll('[data-kkmn-panel].is-active').forEach(function (p) { if (p.getAttribute('data-kkmn-panel') !== 'root') p.classList.remove('is-active'); });
    menu.setAttribute('data-kkmn-active', 'root');
    cover();
    pictures(panel('root'));
    void menu.offsetWidth;                      // commit the closed state so the slide plays
    menu.classList.add('is-open');
    menu.inert = false;
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    root.classList.add('kkmn-is-open');
    mark(true);
  }
  function closeMenu(keepFocus) {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    menu.inert = true;                          // closed: nothing in it can be reached
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Menu');
    root.classList.remove('kkmn-is-open');
    mark(false);
    if (!keepFocus && burger) burger.focus({ preventScroll: true });
  }
  // the bar itself is marked, so it can stand solid above the open sheet
  function mark(open) {
    var section = document.querySelector('.section-header');
    if (section) section.classList.toggle('kkmn-open', open);
  }

  function wireMenu() {
    var found = document.querySelector('[data-kkmn]');
    var opener = document.querySelector('[data-kkmn-open]');
    if (!found || !opener) { menu = null; burger = null; root.classList.remove('kkmn-is-open'); mark(false); return; }
    if (found.__kkmnWired) return;
    found.__kkmnWired = true;
    menu = found; burger = opener;
    root.classList.remove('kkmn-is-open');

    burger.addEventListener('click', function (e) {
      if (wide.matches) return;
      e.preventDefault();
      if (menu.classList.contains('is-open')) closeMenu(); else openMenu();
    });
    // it is a link that acts as a button: a button answers to Space as well as Enter
    burger.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      burger.click();
    });
    menu.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kkmn-close], [data-kkmn-back], [data-kkmn-go], [data-kkmn-fold]');
      if (!t || !menu.contains(t)) return;
      if (t.hasAttribute('data-kkmn-close')) { closeMenu(); return; }
      if (t.hasAttribute('data-kkmn-back')) { back(); return; }
      if (t.hasAttribute('data-kkmn-go') && t.tagName === 'BUTTON') { go(t.getAttribute('data-kkmn-go')); return; }
      if (t.hasAttribute('data-kkmn-fold')) {
        var fold = document.getElementById(t.getAttribute('aria-controls'));
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (fold) fold.classList.toggle('is-open', open);
      }
    });
    var country = menu.querySelector('[data-kkmn-country]');
    if (country) country.addEventListener('change', function () { if (country.form) country.form.submit(); });

    var search = document.querySelector('[data-kkhd-search]');
    if (search && !search.__kkWired) {
      search.__kkWired = true;
      search.addEventListener('click', function () {
        closeMenu(true);
        var real = document.querySelector('.header__icons .header__search > details > summary');
        // once this click has finished: the search panel closes on any click outside itself,
        // and this one, still on its way up the page, would be the first it hears
        if (real) setTimeout(function () { real.click(); }, 0);
      });
    }
  }

  /* ---------- keys, scroll, width ---------- */
  document.addEventListener('keydown', function (e) {
    if (menu && menu.classList.contains('is-open')) {
      if (e.key === 'Escape') { if (stack.length > 1) back(); else closeMenu(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], at = document.activeElement;
      if (f.indexOf(at) === -1) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
      return;
    }
    // Escape closes the whole menu and hands focus back to the link on the bar it opened from.
    if (e.key !== 'Escape' || !root.classList.contains('kkn-is-open')) return;
    // the open item that holds the focus, if one does
    var top = null;
    document.querySelectorAll('.kkn__list > .kkn__item.is-open').forEach(function (item) {
      if (!top || item.contains(document.activeElement)) top = item;
    });
    var to = top && top.contains(document.activeElement) ? trigger(top) : null;
    closeAll();
    if (to) to.focus();
  });

  // the bar slides away on the way down the page: its panels go with it
  var lastY = window.pageYOffset;
  window.addEventListener('scroll', function () {
    if (!root.classList.contains('kkn-is-open')) { lastY = window.pageYOffset; return; }
    if (Math.abs(window.pageYOffset - lastY) > 60) { lastY = window.pageYOffset; closeAll(); }
  }, { passive: true });
  function onWidth() { if (wide.matches) closeMenu(true); else closeAll(); }
  if (wide.addEventListener) wide.addEventListener('change', onWidth);
  else if (wide.addListener) wide.addListener(onWidth);
  window.addEventListener('resize', function () {
    if (root.classList.contains('kkn-is-open') || root.classList.contains('kkmn-is-open')) underBar();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { closeAll(); closeMenu(true); } });

  function scan() {
    // made ahead of time: a backdrop created in the same breath as it is shown has nothing to ease from
    if (document.querySelector('.kkn [data-kkn-trigger]')) backdrop();
    document.querySelectorAll('.kkn__list > [data-kkn-item]').forEach(wire);
    document.querySelectorAll('.kkn [data-kkn-row]').forEach(wireRow);
    wireMenu();
    // the theme editor can swap the header out from under an open panel: the page must not
    // be left dimmed by a menu that is no longer there
    sync();
  }

  window.__kkHeader = { scan: scan, closeAll: closeAll, closeMenu: closeMenu };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function () { setTimeout(scan, 0); });
})();
